module.exports = __webpack_public_path__ + "SamsungOne-700C.8b9e2d7b9662a13e1871.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungOne-700C.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungOne-700C.ttf
// module chunks = styles